import { MapLike } from '../core'
import { ValidBusinessObject } from '../datastoreProxy'
import { AssemblePayloadRequest } from './NetworkTypes'

export enum DeviceTransactionStatus {
  REJECTED_DUPLICATE_DOWNLINK = 'REJECTED_DUPLICATE_DOWNLINK',
  USER_REQUESTED = 'USER_REQUESTED',
  SYSTEM_VERIFIED = 'SYSTEM_VERIFIED',
  SENT_TO_NAS = 'SENT_TO_NAS',
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  FAILED = 'FAILED',
  ACK = 'ACK',
  DEVICE_ACK = 'DEVICE_ACK',
  DEVICE_RESPONSE = 'DEVICE_RESPONSE',
  JOIN_ACCEPT = 'JOIN_ACCEPT',
  DOWNLINK_CONFIG_ERROR = 'DOWNLINK_CONFIG_ERROR',
}

export interface IDeviceControlTransaction {
  ttl: number
  dpk?: string
  dsk?: string
  pk: string
  status: DeviceTransactionStatus
  initialRequest: AssemblePayloadRequest
  iniitalPayloadStr?: string
  requestInitiator: ValidBusinessObject
  timestamp: number
  transactionStages: DeviceControlTransactionStage[]
  /** an optional key to tie DCTs resulting from a single schedule yielding multiple non unique DCTs */
  broadcastScheduleSk?: string
  /** Added for AWS_LPWAN */
  AWS_MessageId?: string
}

/**
 * @type DeviceControlTransactionProps is the constructor argument for DeviceControlTransaction constructor and specifies the device to which the transaction belongs via devicePK
 * use IDeviceControlTransaction for the shape of a DCT Zombie
 */
export type DeviceControlTransactionProps = Omit<IDeviceControlTransaction, 'pk' | 'transactionStages'> & {
  //   ttl: number;
  //   dpk?: string;
  //   dsk?: string;
  devicePk: string
  pk?: string
  //   status: DeviceTransactionStatus;
  //   initialRequest: AssemblePayloadRequest;
  //   requestInitiator: ValidBusinessObject,
  //   timestamp: number,
  transactionStages?: DeviceControlTransactionStage[]
}

export type DeviceControlTransactionStage = {
  timestampsMs: number
  status: DeviceTransactionStatus
  correlationId?: string
  responseObject?: MapLike<any>
}

export type UserDeviceControlRequestMessageObject = Omit<AssemblePayloadRequest, 'WebHook'> & {
  timestampMs: number
  payloadStr?: string | undefined
  /** the key of the inserted device control transaction */
  initialDct: DeviceControlTransactionProps
  AWS_MessageId?: string
}
